import { gateway } from "../../../../gateway";

export type DirectorySearchType = "client" | "workforce" | "vendor";

export interface DirectorySearchItem {
  uid: string;
  firstName: string;
  lastName: string;
  type: DirectorySearchType;
  businessName?: string | null;
  phones: string[];
  source: "flownect";
}

export const searchFlownectDirectory = async (query: string, limit = 20): Promise<DirectorySearchItem[]> => {
  const { data } = await gateway.get("/contact-center/directory-search", {
    params: { query, limit },
  });

  return data?.data?.items ?? [];
};
